// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3395a887","581":"b80fa3e4"}[chunkId] + ".chunk.js";
};